import Pagination from '@mui/material/Pagination';

export { Pagination };
